import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from 'config/api';
import Spinner from 'components/UI/Spinner';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import StyledBadge from 'components/UI/StyledBadge/StyledBadge';
import { getAvailableEvents, getReplayEvents } from '../../ducks/asyncFetcher';
import HomeIntro from 'components/Home/HomeIntro';
import HomeHelp from 'components/Home/HomeHelp';
import News from 'components/UI/News/News';
import Template from 'components/UI/Template/Template';
import EventList from 'components/UI/Event/EventList';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';// import queryString from 'query-string';

import { fetchData, getDataHome, getLoadingError, getSubscriptions } from '../../ducks/asyncFetcher';
import { isLoggedIn, getCurrentUserRole, getCurrentUser, isStateKnown } from 'components/UI/Account/ducks/authentication';
import i18n from 'helpers/i18n';

const styles = (theme) => {
  return {
    root: {
      minWidth: '100%',
      minHeight: '920px',
    },
    headerBanner: {
      backgroundColor: theme.palette.primary.dark,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      fontWeight: 600,
      color: '#fff',
      textAlign: 'center'
    },
    itemTitle: {
      color: theme.palette.secondary.main,
      width: '100%',
      marginBottom: theme.spacing(3),
    },
    itemDate: {
      color: '#6d676d',
      width: '100%',
      fontSize: '0.95rem',
      marginBottom: theme.spacing(2),
    },
    itemThumbnail: {
      backgroundColor: '#f1ddfb'
    },
    badge: {
      transform: 'none',
      top: 'auto',
      right: 'auto',
      position: 'relative',
      color: theme.palette.secondary.dark,
      fontWeight: 'bold',
      // top: theme.spacing(-1.5),
      // right: theme.spacing(-1),
      // right: 0,
      // width: 25,
      // height: 25,
      // fontSize: '1rem',
      alignSelf: 'center',
      marginLeft: 16,
      // borderRadius: '180px',
      [theme.breakpoints.down('sm')]: {
        //   top: theme.spacing(-1),
        width: 20,
        height: 20,
        fontSize: '.8rem'
      }
    },
    tabs: {
      width: '100%',
      maxWidth: 1280,
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      overflow: 'visible',
      marginBottom: theme.spacing(3),
      // flexGrow: 1,
      // borderBottom: '1px '+theme.palette.text.light+' solid',
    },
    tab: {
      '&.Mui-selected': {
        color: theme.palette.secondary.dark
      },
      color: '#858B8E',
      // [theme.breakpoints.down('sm')]: {
      //   marginBottom: theme.spacing(0),
      // },
      '& .MuiTypography-h3': {
        marginBottom: 0,
        fontWeight: 600,
        [theme.breakpoints.down('sm')]: {
          fontSize: '1.8rem',
          // backgroundColor: 'red',
          // marginBottom: theme.spacing(0.5)
          // textAlign: 'center'
        }
      },
      textTransform: 'none',
      position: 'relative',
      maxWidth: 'none',
      overflow: 'visible',
      padding: 0,
      marginRight: theme.spacing(5),
      // paddingTop: theme.spacing(6),
      [theme.breakpoints.down('md')]: {
        // marginRight: 'auto',
        // marginLeft: 'auto',
        // paddingLeft: 22,
        // marginRight: theme.spacing(0),
        // marginBottom: theme.spacing(2),
        // flexGrow: 1,
        // borderBottom: '2px '+theme.palette.secondary.main+' solid'
      },
      [theme.breakpoints.down('xs')]: {
        // marginRight: 'auto',
        // marginLeft: 'auto',
        paddingLeft: 22,
        marginRight: theme.spacing(0),
        marginBottom: theme.spacing(2),
        // flexGrow: 1,
        // borderBottom: '2px '+theme.palette.secondary.main+' solid'
      },

    },
    tabPanel: {
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '100%'
    },
    singleTab: {
      borderBottom: 'none',
      '& .MuiTabs-indicator': {
        display: 'none'
      }
    },
    eventsMainDiv:{
      width: '100%',
      padding:'0 6%',
      [theme.breakpoints.down('sm')]: {
        padding:'0 4%',
      },
      [theme.breakpoints.down('xs')]: {
        padding:'0 2%',
      },
    },
    eventsSubDiv:{
      width: '100%',
    },
  };
};

const AF_KEY = 'home';

const NewsStyled = withStyles((theme) => {
  return {
    root: {
      backgroundImage: 'url('+require('assets/images/header_news.png')+'), linear-gradient(90deg, #2D5E77 0%, #4CA1A6 100%)',
      backgroundSize: 'cover',
      backgroundPosition: '50%',
      backgroundRepeat: 'no-repeat',
      maxWidth: '100%',
      '& .MuiCardContent-root': {
        paddingTop: 0,
        paddingBottom: 0,
      },
      '& .SwipeableTextMobileStepper-card': {
        paddingTop: 0,
        paddingBottom: 0,
      },
      '& .MuiTypography-h2': {
        fontWeight: 'bold'
      },
      '& .MuiTypography-caption': {
        backgroundColor: 'inherit'
      },
    },
    card: {
      paddingTop: 0
    },
    newsWrapper: {
      // backgroundImage: 'url('+require('assets/images/header_news.png')+'), linear-gradient(90deg, #2D5E77 0%, #4CA1A6 100%)',
      // backgroundSize: 'cover',
      // backgroundPosition: '50%',
      // backgroundRepeat: 'no-repeat',
      backgroundColor: 'transparent',
      paddingLeft: theme.spacing(3),
      paddingRight: 0,
      [theme.breakpoints.down('sm')]: {
        paddingLeft: theme.spacing(0),
        // paddingRight: theme.spacing(1),
      }

    },
    newsContentWrapper: {
      paddingTop: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(0),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      }

    },
    newsWrapperPadded: {
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),
    },
    newsHeader: {
      '& .MuiTypography-body1': {
        color: '#fff'
      },
      '& .MuiTypography-caption': {
        color: '#2D5E77',
        textTransform: 'none',
        fontWeight: 600,
        backgroundColor: '#FCB813',
        borderRadius: 35,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      }
    },
    newsSeparator: {
      border: 'none',
      width: 'auto',
      height: 'auto',
      color: '#fff',
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    mediaWrapper: {
      // marginTop: theme.spacing(-2),
    },
    media: {
      width: '100%',
      height: '100%'
      // clipPath: 'circle(73.6% at 80% 49%)',
    },
    buttonNav: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: '#fff'
      }
    },
    guests: {
      '& .MuiTypography-body1': {
        color: '#fff'
      },
      '& .MuiTypography-caption': {
        color: '#fff'
      }
    },
    buttonLeft: {
      [theme.breakpoints.down('md')]: {
        left: 5,
      },
      [theme.breakpoints.down('lg')]: {
        left: 15,
      },
      [theme.breakpoints.up('xl')]: {
        left: 360,
      }
    },
    buttonRight: {
      [theme.breakpoints.down('md')]: {
        right: 5,
      },
      [theme.breakpoints.down('lg')]: {
        right: 15,
      },
      [theme.breakpoints.up('xl')]: {
        right: 360,
      }
    }
  }
})(News);


const HomeIntroStyled = withStyles(theme => ({
  background: {
    backgroundColor: '#FFC337',
    backgroundImage: 'url('+require('assets/images/yellow.png')+'), linear-gradient(90deg, #FCB813 0%, #EB9200 100%)',
    backgroundSize: 'cover',
    width: '100%',
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(20),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    }
  },
  title: {
    color: '#fff',
  },
  subTitle: {
    color: '#fff',
  },
  item: {
    border: '6px transparent solid',
    backgroundColor: '#EFEBEF',
    padding: '1.3rem',
    borderRadius: '180px',
    aspectRatio: 1,
    width: '16rem',
    textAlign: "center",
    margin: '0 auto',
    '& img': {
      width: 78,
      marginTop: 0,
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        width: 65,
        marginTop: 0,
        marginBottom: theme.spacing(.5),
      }
    },
  }
}))(HomeIntro)
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      >
      {value === index && (
        <React.Fragment>{children}</React.Fragment>
      )}
    </div>
  );
}
// TabPanel.propTypes = {
//   children: PropTypes.node,
//   index: PropTypes.any.isRequired,
//   value: PropTypes.any.isRequired,
// };

class HomeClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePanel: 0,
      counterAvailableEvents: 0,
    }
  }
  componentDidMount() {
    // const { classes } = this.props;
    this.props.onMount();
    // document.body.classList.add(classes.withBg);
    // this._onWindowResize();
    // window.addEventListener('resize', this._onWindowResize);
    if (this.props.section) this.scrollToSection(this.props.section)
  }

  componentDidUpdate(oldProps) {
    // if (oldProps.$$data !== this.props.$$data) {
    //   this._onWindowResize();
    // }
    // if (oldProps.section !== this.props.section || oldProps.$$data === undefined && this.props.$$data !== undefined)
    // this.scrollToSection(this.props.section)
  }

  componentWillUnmount() {
    // console.log('unmount')
    // window.removeEventListener('resize', this._onWindowResize);
  }
  scrollToSection = (section) => {
    const elem = document.getElementById(section);
    if (!elem) return
    let rect = elem.getBoundingClientRect();

    window.scroll({
      top: rect.y,
      left: 0,
      behavior: 'smooth',
    });

  }
  // _onWindowResize = () => {
  //   const { classes } = this.props;
  //   const el = document.querySelector('#root');
  //   // console.log('resize', el.offsetHeight, window.innerHeight);
  //   el.style.height = 'auto';
  //   if (el.offsetHeight <= window.innerHeight) {
  //     // console.log('fixing');
  //     el.style.height = window.innerHeight + 'px';
  //   } else {
  //     // console.log('releasing');
  //     el.style.height = 'auto';
  //   }
  // };
  onPanelChange = (event, newValue) => {
    this.setState({activePanel: newValue})

  }
  onCounterChange = (kind, value) => {
    // console.log('counter changed!', kind, value);
    this.setState({counterAvailableEvents: value})
  }
  onReplaysLoaded = () => {
    if (this.props.section === 'replays') {
      // this.scrollToSection('replays')
      }
  }
  render() {
    const { $$data, classes, $$subscriptions, $$availableEvents, $$replayEvents } = this.props;
    const { activePanel, counterAvailableEvents, counterMyEvents } = this.state;
    return (
      <Template current="home" kind={'fullWidth'} maxWidth={'auto'} headerBanner={<Grid item xs={12} className={classes.headerBanner}><LocalHospitalIcon /> {i18n.get('homeBanner', {pretty: false})}</Grid>}>
        <Choose>
          <When condition={$$data !== undefined}>
            <ScrollToTopOnMount />
            <NewsStyled $$data={$$data} newsSeparator={'•'}/>
            <div className={classes.eventsMainDiv}>
            <Hidden xsDown>
              <div className={classes.eventsSubDiv}>
              <If condition={($$availableEvents !== undefined && $$availableEvents.size > 0) || ($$subscriptions !== undefined && $$subscriptions.size > 0 && counterAvailableEvents >0)}>
                <Tabs value={activePanel} onChange={this.onPanelChange} aria-label="Tabs" className={clsx(classes.tabs, {[classes.singleTab]: $$subscriptions === undefined || $$subscriptions.size === 0})}>
                  <If condition={$$availableEvents !== undefined && $$availableEvents.size > 0}>
                    <Tab label={
                        <Typography variant="h3" component="div"><StyledBadge classes={{badge: classes.badge}} badgeContent={counterAvailableEvents} color="secondary">{i18n.get('homeAvailableEvents', {pretty: false})}</StyledBadge></Typography>
                      } overlap="rectangular" className={classes.tab}/>
                    </If>
                    <If condition={$$subscriptions !== undefined && $$subscriptions.size > 0 && counterAvailableEvents >0}>
                      <Tab label={
                          <Typography variant="h3" component="div"><StyledBadge classes={{badge: classes.badge}} badgeContent={$$subscriptions !== undefined ? $$subscriptions.size : 0} color="secondary">{i18n.get('homeYourEvents', {pretty: false})}</StyledBadge></Typography>
                        } className={classes.tab}/>
                      </If>
                    </Tabs>
                  </If>
                  <TabPanel value={activePanel} index={0} className={classes.tabPanel}>
                    <EventList showCount={true} kind="events" eventCardClasses={{itemTitle: classes.itemTitle, itemDate: classes.itemDate, itemThumbnail: classes.itemThumbnail}} onCounterChange={this.onCounterChange} />
                  </TabPanel>
                  <TabPanel value={activePanel} index={1} className={classes.tabPanel}>
                    <EventList showCount={true} kind="events" itemFilter={($$item) => $$subscriptions.contains($$item.get('id'))} eventCardClasses={{itemTitle: classes.itemTitle, itemDate: classes.itemDate, itemThumbnail: classes.itemThumbnail}} />
                  </TabPanel>
                  </div>
                </Hidden>
                <Hidden smUp>
                  <If condition={$$availableEvents !== undefined && $$availableEvents.size > 0}>
                    <div className={classes.tab}>
                      <Typography variant="h3" component="div"><StyledBadge classes={{badge: classes.badge}} badgeContent={counterAvailableEvents} color="secondary">{i18n.get('homeAvailableEvents', {pretty: false})}</StyledBadge></Typography>
                    </div>
                  </If>

                  <div className={classes.eventsSubDiv}>
                    <TabPanel value={99} index={99} className={classes.tabPanel}>
                    <EventList showCount={true} kind="events" eventCardClasses={{itemTitle: classes.itemTitle, itemDate: classes.itemDate, itemThumbnail: classes.itemThumbnail}} onCounterChange={this.onCounterChange} />
                  </TabPanel>
                  </div>

                  <If condition={$$replayEvents !== undefined && $$replayEvents.size > 0}>
                    <div className={classes.tab}>
                      <Typography variant="h3" component="div"><StyledBadge classes={{badge: classes.badge}} badgeContent={counterMyEvents} color="secondary">{i18n.get('homeYourEvents', {pretty: false})}</StyledBadge></Typography>
                    </div>
                  </If>

                  <TabPanel value={99} index={99} className={classes.tabPanel}>
                    <EventList showCount={true} kind="events" itemFilter={($$item) => $$subscriptions.contains($$item.get('id'))} eventCardClasses={{itemTitle: classes.itemTitle, itemDate: classes.itemDate, itemThumbnail: classes.itemThumbnail}}  />
                  </TabPanel>
                </Hidden>
                <EventList title={i18n.get('homeReplays', {pretty: false})} showCount={true} kind="replays" onCounterChange={this.onReplaysLoaded} eventCardClasses={{itemTitle: classes.itemTitle, itemDate: classes.itemDate, itemThumbnail: classes.itemThumbnail}}/>
                </div>
                <HomeIntroStyled $$intro={$$data.get('intro').get('items')}/>
                <Box mb={4} width={'100%'}>
                  <HomeHelp/>
                </Box>
              </When>
              <Otherwise>
                <Spinner>{i18n.get('loading')}</Spinner>
              </Otherwise>
            </Choose>
          </Template>
        );
      }
    }

    function mapStateToProps(state) {
      const props = {
        $$data: getDataHome(state),
        error: getLoadingError(state),
        isLoggedIn: isLoggedIn(state),
        userRole: getCurrentUserRole(state),
        authStateKnown: isStateKnown(state),
        $$user: getCurrentUser(state),
        $$subscriptions: getSubscriptions(state),
        $$availableEvents: getAvailableEvents(state),
        $$replayEvents: getReplayEvents(state),

      };
      return props;
    }
    function mapDispatchToProps(dispatch) {
      return {
        onMount: () => {
          dispatch(fetchData({ key: AF_KEY, fetchUrl: config.home }));
        },
      };
    }

    const HomeWrapper = withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(HomeClass)));

    export default HomeWrapper;



// WEBPACK FOOTER //
// ./src/components/Home/Home.jsx